var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    width: 480,
    height: 480,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14,23c0-4.971,4.029-9,9-9c1.054,0,2.06,0.19,3,0.523V4H4v20c0,1.105,0.895,2,2,2h8.523C14.19,25.06,14,24.054,14,23z M11,7c0-0.552,0.448-1,1-1h6c0.552,0,1,0.448,1,1c0,0.552-0.448,1-1,1h-6C11.448,8,11,7.552,11,7z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23,16c-3.866,0-7,3.134-7,7c0,3.866,3.134,7,7,7s7-3.134,7-7C30,19.134,26.866,16,23,16z M24,26.598V28h-2v-1.394c-1.198-0.259-1.928-1.005-1.952-2.089h1.709c0.044,0.513,0.557,0.84,1.299,0.84c0.669,0,1.128-0.322,1.128-0.786c0-0.391-0.308-0.601-1.113-0.762l-0.928-0.186c-1.289-0.244-1.953-0.947-1.953-2.056c0-1.084,0.69-1.866,1.81-2.154V18h2v1.419c1.088,0.289,1.792,1.049,1.815,2.065H24.16c-0.039-0.498-0.513-0.845-1.143-0.845s-1.045,0.298-1.045,0.767c0,0.386,0.312,0.61,1.055,0.757l0.908,0.176c1.392,0.269,2.017,0.898,2.017,2.017C25.952,25.528,25.227,26.322,24,26.598z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpense);
export default __webpack_public_path__ + "static/media/expense.62898e5ff176efe9583471fa8a672e6d.svg";
export { ForwardRef as ReactComponent };